import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import headingData from '../../detailed-registration/data.js'
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-left-detailed-panel',
  templateUrl: './left-detailed-panel.component.html',
  styleUrls: ['./left-detailed-panel.component.scss']
})
export class LeftDetailedPanelComponent implements OnInit {
  // list = ['Basic Details', 'Manyata Details', 'Other Details', 'Infrastructure Availability', 'Statutory Registrations', 'Staff Details', 'Accreditation Certificates', 'Facility Referral']
  list = [];
  clickedItem: any = '';
  @Output() panelListItem = new EventEmitter();
  @Output() isDisableForm = new EventEmitter();

  isMoved: boolean = false;
  queryParams: any;
  isDisable: boolean = true;
  showIcon = true;
  constructor(private service: AuthService, private router: Router, private route: ActivatedRoute,) {
    headingData[0].map((obj) => {
      if (obj.title !== 'Address') {
        this.list.push(obj.title)
      }
    })

    this.queryParams = this.route.snapshot.queryParams;
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }

    // console.log('after decrypted', this.queryParams);

    if (this.queryParams?.is_profile_updated == 'true') {
      this.showIcon = false;
    }
  }

  ngOnInit(): void {
  }

  handleList(item, index) {
    this.clickedItem = item;
    console.log(this.clickedItem);
    console.log('isMoved', this.isMoved);

    this.isMoved = true;
    this.panelListItem.emit([this.clickedItem == 'Basic Details' ? index : index + 1, this.isMoved])
    // this.service.panelListItem = item
  }

  iconClicked() {
    this.isDisable = !this.isDisable;
    this.isDisableForm.emit(this.isDisable);
    this.showIcon = false;
  }

}
